import { lazy, type ComponentType, type LazyExoticComponent } from 'react';
import { Info, MapPin, Monitor, PanelTop, type LucideIcon } from 'lucide-react';
import { tr } from '../lib/i18n.ts';

export interface SettingsTab {
  /** Stable, Turkish and URL-like: it is what `openSettings('konumlar')` refers to. */
  id: string;
  label: string;
  icon: LucideIcon;
  Panel: LazyExoticComponent<ComponentType>;
}

/**
 * Adding a settings tab: write its component under settings/tabs/ and add one entry here. Order is the
 * order of the tab list. Later tabs (account, notifications) belong at the end, before "Hakkında".
 */
export const SETTINGS_TABS = [
  { id: 'goruntu', label: tr.settings.tabs.display, icon: Monitor, Panel: lazy(() => import('./tabs/DisplayTab.tsx')) },
  { id: 'bilgi-cubugu', label: tr.settings.tabs.infobar, icon: PanelTop, Panel: lazy(() => import('./tabs/InfoBarTab.tsx')) },
  { id: 'konumlar', label: tr.settings.tabs.locations, icon: MapPin, Panel: lazy(() => import('./tabs/LocationsTab.tsx')) },
  { id: 'hakkinda', label: tr.settings.tabs.about, icon: Info, Panel: lazy(() => import('./tabs/AboutTab.tsx')) },
] as const satisfies readonly SettingsTab[];

export type SettingsTabId = (typeof SETTINGS_TABS)[number]['id'];

export const isSettingsTab = (id: string): id is SettingsTabId => SETTINGS_TABS.some((tab) => tab.id === id);
